import React, {useEffect, useState} from "react"
import {Link, useParams} from "react-router-dom"
import {Button} from "@chakra-ui/react"

import {Card, Loading} from "@components/index"

import {gamePlayApiCalls, GamePreviewType} from "@modules/gamePlay/service"
import {Play} from "@modules/gamePlay/components"

export default function Preview() {
    const [game, setGame] = useState<GamePreviewType>()
    const {gameId} = useParams()

    useEffect(() => {
        gamePlayApiCalls.preview(gameId).then(setGame)
    }, [])

    if (!game)
        return <Loading/>

    return <div className="space-y-2">
        <Card
            title={
                <div className="flex justify-between items-center">
                    <div>
                        <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {`Gameplay Preview for ${game.game.info.title}`}
                        </h2>
                        <p className="mt-1 text-sm leading-6 text-gray-600">Your answers won't be saved
                        </p>
                    </div>
                    <Button
                        as={Link}
                        to="/admin/games"
                    >
                        Exit
                    </Button>
                </div>
            }>
        </Card>

        <Play game={game.game}/>
    </div>
}